import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import { useDistributionDiff } from './useDistributionDiff';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { DiffGroupedView } from './DiffGroupedView';
import { IEntityVersionDiffVm, IEntityVersionVm } from '@yakoffice/publisher-types';
import { useDistributionDiffController } from '../../../controllers/useDistributionDiffController';
import { DistributionOverlayHeader } from './DistributionOverlayHeader';
import { DistributionId } from '@yakoffice/publisher-types';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';

interface PropsType {
  gameVersion: IGameVersion,
  gameEnvironment: IGameEnvironment,
  distributionId: DistributionId,
  diffGameVersion: IGameVersion,
  diffGameEnvironment: IGameEnvironment,
  diffDistributionId: DistributionId
}

export const DistributionDiff: FC<PropsType> = observer((props) => {

  const controller = useDistributionDiffController();
  const { setPageTitle } = usePageTitle();
  const [refreshToggle, setRefreshToggle] = useState(true);
  const diffResult = useDistributionDiff(props.gameVersion, props.gameEnvironment, props.distributionId, props.diffGameVersion, props.diffGameEnvironment, props.diffDistributionId, refreshToggle);
  const refreshResult = () => setRefreshToggle(toggle => !toggle);

  const handleMergeEntityDiffs = (modifiedEntities: IEntityVersionDiffVm[]) => {
    if (modifiedEntities.length > 0)
      controller.handleMergeEntityDiffs(props.gameVersion, modifiedEntities, () => refreshResult());
  };

  const handleStopEntities = (entities: IEntityVersionVm[]) => {
    if (entities.length > 0)
      controller.handleStopEntities(entities, () => refreshResult());
  };

  const handleCopyPublishEntities = (entities: IEntityVersionVm[]) => {
    if (entities.length > 0)
      controller.handleCopyPublishEntities(props.diffGameVersion, props.gameVersion, props.gameEnvironment, entities, () => refreshResult());
  };

  const distributionLabel = props.distributionId !== 'published' ? `${props.distributionId} ` : '';
  const diffDistributionLabel = props.diffDistributionId !== 'published' ? `${props.diffDistributionId} ` : '';

  const title =
    <>{distributionLabel} <small
      className="fw-light"> in {props.gameEnvironment.name.toUpperCase()} and game
      version {props.gameVersion.name.toUpperCase()} </small> <i
      className="fas fa-exchange-alt ms-1" />{diffDistributionLabel}<small
      className="fw-light">in {props.diffGameEnvironment.name} and game
      version {props.diffGameVersion.name.toLocaleLowerCase()}</small>
    </>;

  useEffect(() => setPageTitle(['Diff']));

  return <div>
    <DistributionOverlayHeader title={title} />
    {!diffResult.isLoaded || diffResult.distributionDiff == null
      ? <CustomSpinner spinnerText="Loading diff..." />
      : <DiffGroupedView distributionDiff={diffResult.distributionDiff}
                         gameEnvironment={props.gameEnvironment}
                         allowActions={props.distributionId === 'published'}
                         handleMergeEntityDiffs={handleMergeEntityDiffs}
                         handleStopEntities={handleStopEntities}
                         handleCopyPublishEntities={handleCopyPublishEntities}
      />

    }
  </div>;
});
